var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlacesCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66665 11.6667V5.17502C1.66548 4.94139 1.71344 4.71013 1.80742 4.49623C1.9014 4.28234 2.0393 4.09059 2.21217 3.93343C2.38504 3.77628 2.58903 3.65722 2.81089 3.58399C3.03274 3.51076 3.26752 3.48499 3.49998 3.50836L9.83331 4.16669H10.1666L16.5 3.53336C16.7324 3.50999 16.9672 3.53576 17.1891 3.60899C17.4109 3.68222 17.6149 3.80128 17.7878 3.95843C17.9607 4.11559 18.0986 4.30734 18.1925 4.52123C18.2865 4.73513 18.3345 4.96639 18.3333 5.20002V11.6667",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33325 6.50832V10.775C8.33325 10.8583 8.39992 10.9167 8.46659 10.875L11.7999 8.74166C11.8143 8.72839 11.8258 8.71229 11.8337 8.69436C11.8415 8.67643 11.8456 8.65707 11.8456 8.63749C11.8456 8.61792 11.8415 8.59855 11.8337 8.58063C11.8258 8.5627 11.8143 8.54659 11.7999 8.53332L8.46659 6.40833C8.39992 6.36666 8.33325 6.42499 8.33325 6.50832Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26663 14.1665H3.39996C3.82431 14.1665 4.23127 14.3351 4.53133 14.6351C4.83139 14.9352 4.99996 15.3422 4.99996 15.7665V16.6665H1.66663V15.7665C1.66663 15.3422 1.8352 14.9352 2.13526 14.6351C2.43531 14.3351 2.84228 14.1665 3.26663 14.1665V14.1665Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93325 14.1665H10.0666C10.4909 14.1665 10.8979 14.3351 11.198 14.6351C11.498 14.9352 11.6666 15.3422 11.6666 15.7665V16.6665H8.33325V15.7665C8.33325 15.3422 8.50182 14.9352 8.80188 14.6351C9.10194 14.3351 9.50891 14.1665 9.93325 14.1665V14.1665Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 14.1665H16.7333C17.1577 14.1665 17.5646 14.3351 17.8647 14.6351C18.1648 14.9352 18.3333 15.3422 18.3333 15.7665V16.6665H15V15.7665C15 15.5564 15.0414 15.3483 15.1218 15.1542C15.2022 14.9601 15.3201 14.7837 15.4686 14.6351C15.6172 14.4866 15.7936 14.3687 15.9877 14.2883C16.1818 14.2079 16.3899 14.1665 16.6 14.1665V14.1665Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlacesCinema);
export default __webpack_public_path__ + "static/media/ic-places-cinema.5680b02effe5356c1f5c85b97d9fbcb4.svg";
export { ForwardRef as ReactComponent };